import type { BridgeMessageHandler } from '../../message-router.js';
import { handleSessionGitCommitAction } from './handle-session-git-commit.js';
import { handleSessionGitGetChangeFilePatchAction } from './handle-session-git-get-change-file-patch.js';
import { handleSessionGitListChangesAction } from './handle-session-git-list-changes.js';
import { handleSessionGitPushAction } from './handle-session-git-push.js';
import { handleSessionGitStatusAction } from './handle-session-git-status.js';
import { sendSessionGitResult } from './send-session-git-result.js';

export const handleSessionGitRequestMessage: BridgeMessageHandler<'session_git_request'> = (msg, deps) => {
  if (typeof msg.id !== 'string') return;
  const sessionId = typeof msg.sessionId === 'string' ? msg.sessionId : '';
  const action = msg.action;
  if (
    !sessionId ||
    (action !== 'status' &&
      action !== 'push' &&
      action !== 'commit' &&
      action !== 'list_changes' &&
      action !== 'file_diff')
  )
    return;

  void (async () => {
    const ws = deps.getWs();
    const reply = (payload: Record<string, unknown>, encryptedFields: readonly string[] = []) =>
      sendSessionGitResult(ws, msg.id as string, payload, deps.e2ee, encryptedFields);

    try {
      if (action === 'status') {
        await handleSessionGitStatusAction(deps, sessionId, reply);
        return;
      }

      if (action === 'list_changes') {
        await handleSessionGitListChangesAction(deps, { ...msg, sessionId }, reply);
        return;
      }

      if (action === 'file_diff') {
        await handleSessionGitGetChangeFilePatchAction(deps, { ...msg, sessionId }, reply);
        return;
      }

      if (action === 'push') {
        await handleSessionGitPushAction(deps, sessionId, reply);
        return;
      }

      await handleSessionGitCommitAction(deps, sessionId, msg, reply);
    } catch (e) {
      reply({ ok: false, error: e instanceof Error ? e.message : String(e) });
    }
  })();
};
